import { useRef } from 'react';

import { Container } from '@mui/material';
import { useTranslation } from 'react-i18next';

import usePosts from '@/hooks/contentful/usePosts';
import { getPostValues } from '@/utils/posts';

import News from '../News/News';
import {
  ArrowLeft,
  ArrowRight,
  CarouselContainer,
  CarouselTitle,
  Carrousel,
  LoadingSkeletonPost,
} from './style';

function RelevantNews() {
  const { t } = useTranslation();

  const carouselRef = useRef<HTMLDivElement>(null);
  const intervalRef = useRef<NodeJS.Timer>();

  const { posts, isLoading } = usePosts();

  if (posts.length === 0) return <></>;

  const handleScrollLeft = () => {
    if (carouselRef.current != null) {
      carouselRef.current.scrollLeft -= 20;
    }
  };

  const handleScrollLeftHold = () => {
    handleScrollLeft();

    intervalRef.current = setInterval(() => {
      handleScrollLeft();
    }, 50);
  };

  const handleScrollLeftRelease = () => {
    clearInterval(intervalRef.current);
  };

  const handleScrollRight = () => {
    if (carouselRef.current != null) {
      carouselRef.current.scrollLeft += 20;
    }
  };

  const handleScrollRightHold = () => {
    handleScrollRight();

    intervalRef.current = setInterval(() => {
      handleScrollRight();
    }, 50);
  };

  const handleScrollRightRelease = () => {
    clearInterval(intervalRef.current);
  };

  const filtered = posts?.filter((post) => post.fields.featured);
  const quantityOfElements = Array.from({ length: 10 }, (v, i) => i);
  const lastHighlightPost = quantityOfElements.map((el) => filtered[el]);

  return (
    <Container>
      <CarouselContainer>
        <CarouselTitle>{t('BLOG.RELEVANT_NEWS')}</CarouselTitle>

        <Carrousel ref={carouselRef}>
          {lastHighlightPost.map((post) => {
            const data = getPostValues(post);

            const categories = post?.fields.categories?.map(
              (category: any) => category?.fields.categoryName ?? '',
            );

            return isLoading ? (
              <LoadingSkeletonPost
                sx={{ bgcolor: '#DAEDC6' }}
                animation="pulse"
                variant="rectangular"
              />
            ) : (
              post !== undefined && (
                <News
                  category={categories}
                  title={post?.fields.title}
                  key={data.postId}
                  id={data.url}
                  image={data.image}
                />
              )
            );
          })}

          {filtered.length === 1 ? null : (
            <>
              <ArrowLeft
                onMouseDown={handleScrollLeftHold}
                onMouseUp={handleScrollLeftRelease}
                src="/assets/icons/blog/icon_paginado.svg"
                alt="flecha"
              />
              <ArrowRight
                onMouseDown={handleScrollRightHold}
                onMouseUp={handleScrollRightRelease}
                src="/assets/icons/blog/icon_paginado.svg"
                alt="flecha"
              />
            </>
          )}
        </Carrousel>
      </CarouselContainer>
    </Container>
  );
}

export default RelevantNews;
